import angular from 'angular';
import cmsGridDirective from '../../Grid/GridDirective';
import LogResource from '../LogResource'
import GridParamsConverter from '../../Grid/GridParamsConverter';
import gettext from 'angular-gettext';

let logsPageDirective = angular.module('cms.logs.grid', [cmsGridDirective, LogResource, GridParamsConverter, gettext])
    .component('logsGrid', {
        template: require('./logs-grid.html'),
        bindings: {
            initialParams: '<?',
            onParamsChange: '&?',
            onPageChange: '&?',
            gridOptions: '<?'
        },
        controller: function (LogResource, GridParamsConverter, gettextCatalog) {
            /** @ngInject */


            let getColumnDefs = () => {
                return [
                    {headerName: gettextCatalog.getString('User'), field: "ownerName", _translateKey: 'User'},
                    {headerName: "IP", field: "ip"},
                    {headerName: gettextCatalog.getString('Context'), field: "context"},
                    {headerName: gettextCatalog.getString('Event'), field: "event"},
                    {
                        headerName: gettextCatalog.getString('Date'),
                        field: "createdAt",
                        filter: 'date',
                        filterParams: {filterOptions: ['inRange']},
                        valueFormatter: function (data) {
                            if (data && data.value)
                                return (new Date(data.value)).toLocaleString();

                            return data
                        }
                    },
                ];
            };

            let dataInitialized = false;

            const defaultParams = {
                page: undefined,
                order_by: undefined,
                order_direction: undefined,
                ownerName: undefined,
                ip: undefined,
                context: undefined,
                event: undefined,
                createdAtAfter: undefined,
                createdAtBefore: undefined
            };

            this.$onInit = () => {
                if (!this.initialParams)
                    this.initialParams = angular.copy(defaultParams);

                if (this.initialParams.order_by) {
                    this.initialSortModel = [
                        {colId: this.initialParams.order_by, sort: this.initialParams.order_direction || 'asc'}
                    ];
                }

                if (this.initialParams.page) {
                    this.initialPage = this.initialParams.page;
                }

                this.initialFilterModel = {};

                ['ownerName', 'ip', 'context', 'event', 'ownerId'].forEach(field => {
                    if (this.initialParams[field])
                        this.initialFilterModel[field] = ({type: 'contains', filter: this.initialParams[field]});
                });

                ['createdAt'].forEach(field => {
                    if (this.initialParams[field + 'After'] && this.initialParams[field + 'Before'])
                        this.initialFilterModel[field] = ({
                            type: 'inRange',
                            filterType: "date",
                            dateFrom: this.initialParams[field + 'After'],
                            dateTo: this.initialParams[field + 'Before'],
                        });
                });
                this.datasource = {

                    /**
                     * Load next rows function
                     * @param {Object} params Params container
                     * @param {number} params.startRow
                     * @param {number} params.endRow
                     * @param {string} params.sortModel
                     * @param {string} params.filterModel
                     * @param {string} params.context
                     * @param {function} params.successCallback successCallback(rowsThisBlock, lastRow)
                     * @param {function} params.failCallback failCallback(reason)
                     */
                    getRows: params => {
                        let queryParams = GridParamsConverter.getCmsApiParams(params);
                        let stateParams = Object.assign({}, defaultParams, queryParams);
                        if (this.onParamsChange) {
                            this.onParamsChange({$params: angular.copy(stateParams)})
                        }

                        let logs = LogResource.get(queryParams, response => {
                            let data = logs.data;
                            let lastRow = logs.total_count;
                            params.successCallback(data, lastRow);

                            if (!dataInitialized && this.initialPage && this.initialPage !== this.griOptions.api.paginationGetCurrentPage() + 1) {
                                dataInitialized = true;
                                this.gridOptions.api.paginationGoToPage(parseInt(this.initialPage) - 1);
                            }

                            if (!this.resizeOnFirstLoad) {
                                this.gridOptions.api.sizeColumnsToFit();
                                this.resizeOnFirstLoad = true;
                            }
                        })
                    }
                };

            };
            this._onPageChange = page => {
                if (!dataInitialized)
                    return;
                if (this.onPageChange) {
                    this.onPageChange({$page: page});
                }
            };

            this.gridOptions = {
                _columnDefsCallback: getColumnDefs,
                _gridStateId: 'log-grid-state'
            };

            // Access to grid via this.options.api obj.
            // API object is accessible after grid initialization

        }
    });

export default logsPageDirective.name;




// WEBPACK FOOTER //
// ./src/cmsCore/LogsModules/LogsGrid/LogsGrid.js